import React from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./BrokerCard.css";

const BrokerCard = ({
  logoSrc,
  logoAlt,
  name,
  subtitle,
  status,
  onClick,
  infoTooltip,
  disabled
}) => {
  return (
    <button
      type="button"
      className={`broker-card ${disabled ? "is-disabled" : ""}`}
      onClick={onClick}
      aria-label={`Login with ${name}`}
      disabled={disabled}
    >
      <div className="broker-card-content">
        <img
          className="broker-card-logo"
          src={logoSrc}
          alt={logoAlt || `Broker logo: ${name}`}
          width={name === "Jainam Duck" || name === "Open XTS" || name === "Zebu" || name === "Arrow" ? "60px" : "32px"}
          height="32px"
          loading="lazy"
        />
        <div className="broker-card-text">
          <div className="broker-card-title-row">
            <span className="broker-card-name">{name}</span>
            {/* {infoTooltip ? (
              <Tooltip title={infoTooltip} placement="top">
                <span className="broker-card-info" aria-label="More info">
                  <FontAwesomeIcon icon={"info-circle"} />
                </span> 
              </Tooltip>
            ) : null} */}
          </div>
        </div>
      </div>
    </button>
  );
};

export default BrokerCard;


